(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter-sidebar"] && !Shopify.designMode) return;
  try {
    (function() {
    /* Accordion: single-open toggle via event delegation (survives AJAX replacements) */
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-filter-toggle]');
      if (!toggle) return;

      var section = toggle.closest('[data-filter-section]');
      if (!section) return;

      var content = section.querySelector('[data-filter-content]');
      var chevron = section.querySelector('[data-filter-chevron]');
      if (!content) return;

      var isOpen = !content.classList.contains('hidden');

      /* Close all sections first (scope to the toggle's own form) */
      var form = toggle.closest('form');
      if (form) {
        form.querySelectorAll('[data-filter-content]').forEach(function(c) {
          c.classList.add('hidden');
        });
        form.querySelectorAll('[data-filter-chevron]').forEach(function(ch) {
          ch.classList.remove('rotate-180');
        });
      }

      /* Toggle this section (if it was closed, open it) */
      if (!isOpen) {
        content.classList.remove('hidden');
        if (chevron) chevron.classList.add('rotate-180');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
